<page-load-header *ngIf="!initialized"></page-load-header>


<div *ngIf="initialized" class="container space-1">
  <h3>VIP & Staff Guest Rooms</h3>
  <p>Hi <strong>{{ model.user.fullName }}</strong>! Please use the form below to keep us posted of your travel needs/dates. Any time you update this form, we will get notified and modify your reservation accordingly.</p>

  <ng-container *ngIf="initialized">
    <form class="form" #myForm="ngForm" (ngSubmit)="onSave()" novalidate>

      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Opt-In to Room</label>
            <select class="form-control" name="optedInForRoom" required [(ngModel)]="model.optedInForRoom">
              <option [ngValue]="null">Please choose...</option>
              <option [ngValue]="true">Yes, I need a room</option>
              <option [ngValue]="false">No room required</option>
            </select>
            <div class="invalid-message">
              <div>Opt-In Is required</div>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="model.optedInForRoom">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Check-in Date</label>
              <kendo-datepicker #startDatePicker [min]="startDate" (open)="openStart()" required [max]="endDate" class="form-control" placeholder="" [(ngModel)]="model.checkinDate" name="checkinDate"></kendo-datepicker>
              <div class="invalid-message">
                <div>Checkin Date is required</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Check-out Date</label>
              <kendo-datepicker #endDatePicker (open)="openEnd()" [min]="startDate" required [max]="endDate" class="form-control" placeholder="" [(ngModel)]="model.checkOutDate" name="checkOutDate"></kendo-datepicker>
              <div class="invalid-message">
                <div>Checkout Date is required</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Room Type</label>
              <select class="form-control" required [compareWith]="compare" [(ngModel)]="model.roomType" name="roomType">
                <option [ngValue]="null">Please choose...</option>
                <option *ngFor="let rType of types" [ngValue]="rType">{{ rType.name }}</option>

              </select>
              <div class="invalid-message">
                <div>Room Type is required</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Confirmation Number</label>
              <input readonly class="form-control readonly" [(ngModel)]="model.confirmationNumber" name="confirmationNumber">
              <div class="invalid-message">
                <div>Room Name is required</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Notes/Special Requests</label>
              <textarea class="form-control" [(ngModel)]="model.notes" name="notes"></textarea>
              <div class="invalid-message">
                <div>Notes Name is required</div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>


      <div class="modal-footer mb-5">
        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-sm btn-secondary mr-2" type="submit">
              <span>Update</span>
            </button>
            <button class="btn btn-sm btn-outline-dark" (click)="onCancel()" [promiseBtn]="submitComplete" type="button">Cancel</button>
          </div>
        </div>
      </div>

    </form>
  </ng-container>

</div>
